import podcastPaymentStatus from 'enums/campaigns/podcastPaymentStatus';

const getOfferPodcastPayment = (offer) =>
  podcastPaymentStatus[offer.podcastPaymentStatus] ||
  podcastPaymentStatus.pending;

export default getOfferPodcastPayment;
